import { ScraperStatusIF } from '../settings/types'

export interface ProviderIF {
    id: number
    name: string
    scraperProviderId?: number
}

export enum ACCOUNT_STATUS {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    ARCHIVED = 'ARCHIVED',
    DISABLED_MAX_WIN = 'DISABLED_MAX_WIN',
    ERROR = 'ERROR',
    LOGIN_ERROR = 'LOGIN_ERROR',
    INVALID_LOGIN = 'INVALID_LOGIN',
    CALL_CUSTOMER_SERVICE = 'CALL_CUSTOMER_SERVICE',
    PROXY_ERROR = 'PROXY_ERROR',
    LIVE_ERROR = 'LIVE_ERROR',
    BET_SETTINGS_ERROR = 'BET_SETTINGS_ERROR'
}

export interface AccountProviderIF {
    providerId?: number
    accountId?: number
    id?: number
    account: AccountIF
    provider: ProviderIF
}

export interface AccountProviderScraperIF
    extends AccountProviderIF,
    ScraperStatusIF { }

export interface AccountIF {
    id: number
    username: string
    password: string
    website: string
    tags: string[]
    proxyCity?: string
    proxyState?: string
    accountProviders: AccountProviderIF[]
    autoBetAmount: number
    winTotal?: number
    liability?: number
    isScraperAccount: boolean
    source?: string
    status: ACCOUNT_STATUS
    supportedBetTypes: string[]
    supportedBetIntervals: string[]
    supportedBetLeagues: string[]
    currency?: string
    family?: string
    subSource?: string
    rebet?: boolean
    userAccounts: UserAccountsIF[]
}
export interface AccountScraperIF extends AccountIF {
    accountProviders: AccountProviderScraperIF[]
}

export interface AccountMetadataIF {
    id: number
    activity: AccountActivityIF[]
    lastCompletedBet?: string
    lastAttemptedBet?: string
}

export interface AccountActivityIF {
    activity: string
    createdAt: Date
}

export type AccountWithMetadataIF = AccountScraperIF & AccountMetadataIF

export type UserAccountsIF = {
    id?: number;
    accountId?: number;
    userId?: number;
    user: UserIF
}

export type UserIF = {
    id: number;
    username: string;
    password: string;
    role: string;
    email?: string;
    createdAt: Date;
    updatedAt: Date;
}
